export const UMA_GET_MODEL_DIRTY_REIMPORT = {
	success: true,
	errors: [
		{
			'code': 'MODEL_IS_MODIFIED_AT_SOURCE',
			'message': 'yes',
			'details': 'The model has been modified at source since its last import'
		},
		{
			'code': 'MODEL_IS_OVERRIDDEN_AT_BLK',
			'message': 'yes',
			'details': 'The model has not been reimported from partner platform'
		}

	],
	status: 'OK',
	response: {
		id: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
		description: 'UMA REIMPORTED DIRTY',
		type: 'PORTFOLIO',
		subType: 'THIRD_PARTY_MODEL',
		children: [
			{
				identifier: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
				identifierType: 'CUSTOM',
				weight: 20,
				allData: {
					date: 1575900025096,
					positionType: 'INVALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 20,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070329,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'BD-IPB',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'Inflation-Protected Bond',
						type: 'ASSET_CLASS'
					},
					userTrackingId: '2555447',
					uniqueId: '06fe8362-a87b-448a-a32e-1f9ae668abae'
				}
			},
			{
				identifier: 'TIP@464287176@US4642871762',
				identifierType: 'SECURITY_ID',
				weight: 20,
				allData: {
					date: 1575900025096,
					positionType: 'SUBSTITUTED',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					mappedFrom: [
						'ENVESTNET_HANDLE@0100000AEEN01198677HVOIYLHVLOOZUFVOOC37QXCP4ANF56ICXCJR44YHWHYIWU4FISHVQ===='
					],
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					commonIdentifier: 'TIP@464287176@US4642871762',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'TIP@464287176@US4642871762',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 20,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070328,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					userTrackingId: '2555447',
					uniqueId: 'a1f67a77-d605-4827-ac35-de6a6739c439'
				}
			},
			{
				identifier: 'IJR@464287804@US4642878049',
				identifierType: 'SECURITY_ID',
				weight: 20,
				allData: {
					date: 1575900025096,
					positionType: 'VALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'SECURITY_ID',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					commonIdentifier: 'IJR@464287804@US4642878049',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'IJR@464287804@US4642878049',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 20,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070329,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO',
					commonIdentifierType: 'SECURITY_ID',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN0115899HGFAVAVZGW3L2TUYQNKT2D4GM4KM6P7P7PUD2BNKMEKNEBYYQPEIQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: '464287804',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSIP'
						},
						{
							identifier: 'IJR',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'iShares Core S&P Small-Cap',
						type: 'SECURITY'
					},
					userTrackingId: '2555447',
					uniqueId: '383159ef-a789-46e8-bdde-2b7432488a56'
				}
			},
			{
				identifier: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
				identifierType: 'CUSTOM',
				weight: 10,
				allData: {
					date: 1575900025096,
					positionType: 'INVALID',
					'@type': '_bws.user.WebUserData',
					identifierType: 'CUSTOM',
					type: 'PORTFOLIO_POSITION',
					currentUserIsOwner: true,
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					userEmail: 'apm6@rockymountainsideweatlh.com',
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'ENVESTNET_HANDLE@0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
					trackingType: 'userData',
					userPlatformId: '3224231',
					childFlag: true,
					level: 1,
					updateUserId: 'apm6@rockymountainsideweatlh.com',
					weight: 10,
					userId: 'apm6@rockymountainsideweatlh.com',
					updateTimestamp: 1575900070329,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO',
					otherIdentifiers: [
						{
							identifier: '0100000AEEN0112054585HLENSSL5ILBY4643LJKLP2BJEPVIDZ3P2AONYDXGPAE3WDFE25VUQ====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'TLO.BFD',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					originPlatform: {
						name: 'Blackrock Global Equity',
						type: 'SECURITY'
					},
					userTrackingId: '2555447',
					uniqueId: 'a17d06d2-5392-4024-9c4b-c64205edb3ed'
				}
			},
			{
				identifier: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
				identifierType: 'CUSTOM',
				weight: 10,
				portfolio: {
					id: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
					description: 'Advisor Sleeve Model',
					type: 'PORTFOLIO',
					subType: 'THIRD_PARTY_MODEL',
					children: [
						{
							identifier: 'WOOD@464288174@US4642881746',
							identifierType: 'SECURITY_ID',
							weight: 50,
							allData: {
								date: 1575900025096,
								positionType: 'INVALID',
								'@type': '_bws.user.WebUserData',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1575900063898,
								dateLastModified: 1575900063898,
								userEmail: 'apm6@rockymountainsideweatlh.com',
								commonIdentifier: 'WOOD@464288174@US4642881746',
								owner: {
									userPlatformId: '3224231',
									userEmail: 'apm6@rockymountainsideweatlh.com',
									userId: 'apm6@rockymountainsideweatlh.com'
								},
								identifier: 'WOOD@464288174@US4642881746',
								trackingType: 'userData',
								userPlatformId: '3224231',
								childFlag: true,
								level: 1,
								updateUserId: 'apm6@rockymountainsideweatlh.com',
								weight: 50,
								userId: 'apm6@rockymountainsideweatlh.com',
								updateTimestamp: 1575900070328,
								parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: '0100000AEEN011192576H6K4MYB7664FQ2PJX6TVBDASOOA45VPJHM2YX6H3F742XF3MXETRQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464288174',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'WOOD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								originPlatform: {
									name: 'iShares Global Timber & Forestry ETF',
									type: 'SECURITY'
								},
								userTrackingId: '2555447',
								uniqueId: 'd792bbad-0490-4bc0-a140-3119919778e9'
							}
						},
						{
							identifier: 'IVV@464287200@US4642872000',
							identifierType: 'SECURITY_ID',
							weight: 50,
							allData: {
								date: 1575900025096,
								positionType: 'VALID',
								'@type': '_bws.user.WebUserData',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1575900063898,
								dateLastModified: 1575900063898,
								userEmail: 'apm6@rockymountainsideweatlh.com',
								commonIdentifier: 'IVV@464287200@US4642872000',
								owner: {
									userPlatformId: '3224231',
									userEmail: 'apm6@rockymountainsideweatlh.com',
									userId: 'apm6@rockymountainsideweatlh.com'
								},
								identifier: 'IVV@464287200@US4642872000',
								trackingType: 'userData',
								userPlatformId: '3224231',
								childFlag: true,
								level: 1,
								updateUserId: 'apm6@rockymountainsideweatlh.com',
								weight: 50,
								userId: 'apm6@rockymountainsideweatlh.com',
								updateTimestamp: 1575900070328,
								parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: 'IVV',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									},
									{
										identifier: '0100000AEEN01112384HMJEGBS55DXNO7PUUUQQMG5B3RMF3DDTGCID24QCMO2XC5Y57ZOSA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287200',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									}
								],
								originPlatform: {
									name: 'iShares Core S&P 500',
									type: 'SECURITY'
								},
								userTrackingId: '2555447',
								uniqueId: 'f5d32ef7-97a8-4df6-84ee-9bea191b89f3'
							}
						}
					],
					allData: {
						date: 1561372463377,
						'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
						origin: 'partner',
						flags: {
							originContainsEditableModel: true,
							originIsfirstTimeImported: true,
							originContainsUnsupportedSMA: false,
							inputWithValues: false,
							isProcessed: false,
							originContainsUnmatchedSecurities: false,
							originContainsUnsupportedManagedAccount: false,
							originContainsAssetClassSubstitutions: false,
							originContainsSleeves: false
						},
						description: 'Advisor Sleeve Model',
						type: 'PORTFOLIO',
						currentUserIsOwner: true,
						parentFlag: true,
						dateCreated: 1561372463377,
						dateLastModified: 1575900063898,
						userEmail: 'apm6@rockymountainsideweatlh.com',
						perms: {
							DELETE: [
								'webUserDataPerm@AdvisorPort'
							],
							SHARE: [
								'webUserDataPerm@AdvisorPort'
							],
							VIEW: [
								'webUserDataPerm@AdvisorPort'
							]
						},
						owner: {
							userPlatformId: '3224231',
							userEmail: 'apm6@rockymountainsideweatlh.com',
							userId: 'apm6@rockymountainsideweatlh.com'
						},
						ssoIdp: 'envestnet',
						toolOrigin: 'partner',
						trackingType: 'userData',
						userPlatformId: '3224231',
						updateUserId: 'apm6@rockymountainsideweatlh.com',
						childCount: 2,
						userId: 'apm6@rockymountainsideweatlh.com',
						updateTimestamp: 1575900070330,
						otherIdentifiers: [
							{
								identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
								customIdentifierType: 'ENVESTNET_HANDLE',
								'@type': '_bws.investments.IdentifierParam',
								identifierType: 'CUSTOM'
							}
						],
						subType: 'THIRD_PARTY_MODEL',
						originPlatform: {
							firm: 'demof',
							dateImported: '1561372463360',
							programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
							externalModelDateLastModified: '1575899995393',
							riskHandle: '0100000AOOP03321HTZQ7VWJVZ2P2NE37Q6EBTMYEEZXYQSSSQHLLZVDZUMUSKTJBMLZA====',
							platform: 'ENVESTNET'
						},
						userTrackingId: '2555447',
						uniqueId: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
						applications: [
							'partner',
							'bfa'
						]
					}
				},
				allData: {
					date: 1575900025096,
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'e2e2551a-f70b-4daa-a4ba-d2157956313d',
					trackingType: 'userData',
					positionType: 'VALID',
					childFlag: true,
					'@type': '_bws.user.WebUserData',
					description: 'AS-1483',
					weight: 10,
					identifierType: 'CUSTOM',
					userId: 'apm6@rockymountainsideweatlh.com',
					currentUserIsOwner: true,
					updateTimestamp: 1575900070328,
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					score: 1,
					dateCreated: 1575900063898,
					dateLastModified: 1575900063898,
					otherIdentifiers: [
						{
							identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'AS-1483',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					userEmail: 'apm6@rockymountainsideweatlh.com',
					subType: 'HOLDING',
					originPlatform: {
						name: 'APM Sleeve Model',
						type: 'APM_SLEEVE'
					}
				}
			},
			{
				identifier: 'f09-b45',
				identifierType: 'CUSTOM',
				weight: 10,
				portfolio: {
					id: 'f09-b45',
					description: 'Advisor Sleeve Model-2',
					type: 'PORTFOLIO',
					subType: 'THIRD_PARTY_MODEL',
					children: [
						{
							identifier: 'XYZ@464288174@US4642881746',
							identifierType: 'SECURITY_ID',
							weight: 50.0,
							allData: {
								date: 1575900025096,
								positionType: 'INVALID',
								'@type': '_bws.user.WebUserData',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1575900063898,
								dateLastModified: 1575900063898,
								userEmail: 'apm6@rockymountainsideweatlh.com',
								commonIdentifier: 'WOOD@464288174@US4642881746',
								owner: {
									userPlatformId: '3224231',
									userEmail: 'apm6@rockymountainsideweatlh.com',
									userId: 'apm6@rockymountainsideweatlh.com'
								},
								identifier: 'WOOD@464288174@US4642881746',
								trackingType: 'userData',
								userPlatformId: '3224231',
								childFlag: true,
								level: 1,
								updateUserId: 'apm6@rockymountainsideweatlh.com',
								weight: 50,
								userId: 'apm6@rockymountainsideweatlh.com',
								updateTimestamp: 1575900070328,
								parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: '0100000AEEN011192576H6K4MYB7664FQ2PJX6TVBDASOOA45VPJHM2YX6H3F742XF3MXETRQ====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464288174',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									},
									{
										identifier: 'WOOD',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									}
								],
								originPlatform: {
									name: 'iShares Global Timber & Forestry ETF',
									type: 'SECURITY'
								},
								userTrackingId: '2555447',
								uniqueId: 'd792bbad-0490-4bc0-a140-3119919778e9'
							}
						},
						{
							identifier: 'IVV@464287200@US4642872000',
							identifierType: 'SECURITY_ID',
							weight: 50.0,
							allData: {
								date: 1575900025096,
								positionType: 'VALID',
								'@type': '_bws.user.WebUserData',
								identifierType: 'SECURITY_ID',
								type: 'PORTFOLIO_POSITION',
								currentUserIsOwner: true,
								score: 1,
								dateCreated: 1575900063898,
								dateLastModified: 1575900063898,
								userEmail: 'apm6@rockymountainsideweatlh.com',
								commonIdentifier: 'IVV@464287200@US4642872000',
								owner: {
									userPlatformId: '3224231',
									userEmail: 'apm6@rockymountainsideweatlh.com',
									userId: 'apm6@rockymountainsideweatlh.com'
								},
								identifier: 'IVV@464287200@US4642872000',
								trackingType: 'userData',
								userPlatformId: '3224231',
								childFlag: true,
								level: 1,
								updateUserId: 'apm6@rockymountainsideweatlh.com',
								weight: 50,
								userId: 'apm6@rockymountainsideweatlh.com',
								updateTimestamp: 1575900070328,
								parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
								parentType: 'PORTFOLIO',
								commonIdentifierType: 'SECURITY_ID',
								otherIdentifiers: [
									{
										identifier: 'IVV',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'TICKER'
									},
									{
										identifier: '0100000AEEN01112384HMJEGBS55DXNO7PUUUQQMG5B3RMF3DDTGCID24QCMO2XC5Y57ZOSA====',
										customIdentifierType: 'ENVESTNET_HANDLE',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSTOM'
									},
									{
										identifier: '464287200',
										'@type': '_bws.investments.IdentifierParam',
										identifierType: 'CUSIP'
									}
								],
								originPlatform: {
									name: 'iShares Core S&P 500',
									type: 'SECURITY'
								},
								userTrackingId: '2555447',
								uniqueId: 'f5d32ef7-97a8-4df6-84ee-9bea191b89f3'
							}
						}
					],
					allData: {
						date: 1561372463377,
						'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
						origin: 'partner',
						flags: {
							originContainsEditableModel: true,
							originIsfirstTimeImported: true,
							originContainsUnsupportedSMA: false,
							inputWithValues: false,
							isProcessed: false,
							originContainsUnmatchedSecurities: false,
							originContainsUnsupportedManagedAccount: false,
							originContainsAssetClassSubstitutions: false,
							originContainsSleeves: false
						},
						description: 'Advisor Sleeve Model-2',
						type: 'PORTFOLIO',
						currentUserIsOwner: true,
						parentFlag: true,
						dateCreated: 1561372463377,
						dateLastModified: 1575900063898,
						userEmail: 'apm6@rockymountainsideweatlh.com',
						perms: {
							DELETE: [
								'webUserDataPerm@AdvisorPort'
							],
							SHARE: [
								'webUserDataPerm@AdvisorPort'
							],
							VIEW: [
								'webUserDataPerm@AdvisorPort'
							]
						},
						owner: {
							userPlatformId: '3224231',
							userEmail: 'apm6@rockymountainsideweatlh.com',
							userId: 'apm6@rockymountainsideweatlh.com'
						},
						ssoIdp: 'envestnet',
						toolOrigin: 'partner',
						trackingType: 'userData',
						userPlatformId: '3224231',
						updateUserId: 'apm6@rockymountainsideweatlh.com',
						childCount: 2,
						userId: 'apm6@rockymountainsideweatlh.com',
						updateTimestamp: 1575900070330,
						otherIdentifiers: [
							{
								identifier: '0100000NOOP0070HLTNBOQFVMHA7NXPXINK3KV2DUU======',
								customIdentifierType: 'ENVESTNET_HANDLE',
								'@type': '_bws.investments.IdentifierParam',
								identifierType: 'CUSTOM'
							}
						],
						subType: 'THIRD_PARTY_MODEL',
						originPlatform: {
							firm: 'demof',
							dateImported: '1561372463360',
							programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
							externalModelDateLastModified: '1575899995393',
							riskHandle: '0100000AOOP03321HTZQ7VWJVZ2P2NE37Q6EBTMYEEZXYQSSSQHLLZVDZUMUSKTJBMLZA====',
							platform: 'ENVESTNET'
						},
						userTrackingId: '2555447',
						uniqueId: 'f09-b45',
						applications: [
							'partner',
							'bfa'
						]
					}
				},
				allData: {
					identifier: 'f09-b45',
					otherIdentifiers: [
						{
							identifier: 'AS-2',
							identifierType: 'TICKER'
						},
						{
							customIdentifierType: 'ENVESTNET_HANDLE',
							identifierType: 'CUSTOM'
						}
					],
					positionType: 'INVALID',
					weight: 10,
					identifierType: 'CUSTOM',
					originPlatform: {
						name: 'apmModel TWO',
						type: 'APM_SLEEVE'
					}
				}
			},
			{
				identifier: '270892',
				identifierType: 'MODEL_ID',
				weight: 10,
				allData: {
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: '270892',
					otherIdentifiers: [
						{
							identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'FSP3010',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					positionType: 'VALID',
					weight: 10,
					identifierType: 'MODEL_ID',
					originPlatform: {
						name: 'Model Portfolio 10/90',
						type: 'MANAGED_MODEL'
					},
					type: 'PORTFOLIO_POSITION',
					uniqueId: '06dfe362-a87b-448a-a32e-1f9ae668abde',
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO'
				}
			},
			{
				identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
				identifierType: 'CUSTOM',
				weight: 10,
				allData: {
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
					otherIdentifiers: [
						{
							identifier: '0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINR5ERBVBA====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'FSPLMCBSLG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					positionType: 'INVALID',
					weight: 10,
					identifierType: 'CUSTOM',
					originPlatform: {
						name: 'ClearBridge Large Cap Growth ESG',
						type: 'MANAGED_MODEL'
					},
					type: 'PORTFOLIO_POSITION',
					uniqueId: '06fe8362-a87b-448a-a32e-1f9ae668abae',
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO'
				}
			},
			{
				identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
				identifierType: 'CUSTOM',
				weight: 10,
				allData: {
					owner: {
						userPlatformId: '3224231',
						userEmail: 'apm6@rockymountainsideweatlh.com',
						userId: 'apm6@rockymountainsideweatlh.com'
					},
					identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
					otherIdentifiers: [
						{
							identifier: 'ENVESTNET_HANDLE0100000NOOP011295836HFTFBL3QDEAQ53T5D4RNLQZJYSBBIZGP2KUX2665R2JINOPTHYB====',
							customIdentifierType: 'ENVESTNET_HANDLE',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'CUSTOM'
						},
						{
							identifier: 'ACM-LMCBSLG',
							'@type': '_bws.investments.IdentifierParam',
							identifierType: 'TICKER'
						}
					],
					positionType: 'INVALID',
					weight: 10,
					identifierType: 'CUSTOM',
					originPlatform: {
						name: 'Separately Managed Model',
						type: 'SMA'
					},
					type: 'PORTFOLIO_POSITION',
					uniqueId: '0dcb8362-a87b-448a-a32e-1f9ae668arth',
					parentId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					parentType: 'PORTFOLIO'
				}
			}
		],
		allData: {
			origin: 'partner',
			flags: {
				originContainsEditableModel: true,
				originIsfirstTimeImported: true,
				originContainsUnsupportedSMA: true,
				inputWithValues: false,
				isProcessed: false,
				originContainsUnmatchedSecurities: true,
				originContainsUnsupportedManagedAccount: true,
				originContainsAssetClassSubstitutions: true,
				originSleeveContainsUnmatchedSecurities: true,
				originContainsSleeves: true
			},
			description: 'UMA REIMPORTED DIRTY',
			type: 'PORTFOLIO',
			parentFlag: true,
			dateCreated: 1561372463377,
			dateLastModified: 1575900063898,
			userEmail: 'apm6@rockymountainsideweatlh.com',
			perms: {
				DELETE: [
					'webUserDataPerm@AdvisorPort'
				],
				SHARE: [
					'webUserDataPerm@AdvisorPort'
				],
				VIEW: [
					'webUserDataPerm@AdvisorPort'
				]
			},
			owner: {
				userPlatformId: '3224231',
				userEmail: 'apm6@rockymountainsideweatlh.com',
				userId: 'apm6@rockymountainsideweatlh.com'
			},
			ssoIdp: 'envestnet',
			toolOrigin: 'partner',
			userPlatformId: '3224231',
			level: 0,
			updateUserId: 'apm6@rockymountainsideweatlh.com',
			childCount: 9,
			userId: 'apm6@rockymountainsideweatlh.com',
			updateTimestamp: 1575900070330,
			otherIdentifiers: [
				{
					identifier: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
					customIdentifierType: 'ENVESTNET_HANDLE',
					'@type': '_bws.investments.IdentifierParam',
					identifierType: 'CUSTOM'
				}
			],
			subType: 'THIRD_PARTY_MODEL',
			originPlatform: {
				firm: 'demof',
				dateImported: '1561372463360',
				programHandle: '0100000AEEN01613H3MJAZEPFRG6GLHUIJ76FX664I5JKQH6OH6I5XGYWSI3Z6KJBLQLA====',
				externalModelDateLastModified: '1575899995393',
				riskHandle: '0100000AOOP03321HTZQ7VWJVZ2P2NE37Q6EBTMYEEZXYQSSSQHLLZVDZUMUSKTJBMLZA====',
				platform: 'ENVESTNET'
			},
			userTrackingId: '2555447',
			uniqueId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
			applications: [
				'partner',
				'bfa'
			]
		}
	},
	responseTimes: {
		root: {
			nodes: []
		}
	}
};
